import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Maintenance from "@/components/Maintenance";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <Maintenance />
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;

